import { render, staticRenderFns } from "./TradeMarketplaceProductList.vue?vue&type=template&id=29f5e2f4&"
import script from "./TradeMarketplaceProductList.vue?vue&type=script&lang=js&"
export * from "./TradeMarketplaceProductList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports